import { ShadcnAutoCompleteFilters, ShadcnAutoCompleteSearch } from "Explore/Components";
import { getSuggestSearchInstitutions } from "Explore/Services/Institution";
import styles from "./FiltersUnit.module.scss";
import { getSuggestKeywords } from "Explore/Services/Common";
import {
  KEYWORD_TIME_FILTER_KEYS,
  ParamsFilterKey,
} from "Config/filterSearchParams";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { getSuggestSearchUnits } from "Explore/Services/Unit";
import { ToggleGroup, ToggleGroupItem } from "components/ui/toggle-group";
import { RotateCcw } from "lucide-react";

const FiltersUnit = ({
  filter: filterProps,
  updateFilter: updateFilterProps,
}) => {
  const { filter: _filter, updateSearchParams: _updateSearchParams, resetFilter } =
    useFilterAndPagination();
  const filter = filterProps || _filter;
  const updateFilter = updateFilterProps || _updateSearchParams;

  return (
    <div className="flex flex-col gap-8 p-6 bg-white rounded-lg shadow-sm border border-gray-100 h-fit xl:sticky xl:top-[90px] xl:max-h-[calc(100vh-100px)] xl:overflow-y-auto xl:mt-[96px] w-full xl:max-w-[300px]">
      
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Filters</h3>
        <button
          onClick={resetFilter}
          className="text-xs text-gray-400 hover:text-gray-700 flex items-center gap-1.5 transition-colors"
        >
          <RotateCcw size={12} />
          Clear filters
        </button>
      </div>
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Name
        </label>
        <ShadcnAutoCompleteSearch
          placeholder={"Search by unit"}
          functionSearch={getSuggestSearchUnits}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.QUERY}
        />
      </div>

      {/* Research interest */}
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Research interest
        </label>
        
        <div className="flex flex-col gap-1.5">
          <span className="text-xs text-gray-500 font-medium">Type:</span>
          <ToggleGroup 
            type="single" 
            value={filter[ParamsFilterKey.KEYWORD_TIME_FILTER]}
            onValueChange={(val) => {
              if (val) updateFilter({ [ParamsFilterKey.KEYWORD_TIME_FILTER]: val });
            }}
            className="w-full border border-gray-200 rounded-md p-1 bg-gray-100 flex"
          >
            {Object.keys(KEYWORD_TIME_FILTER_KEYS).map((key) => (
              <ToggleGroupItem 
                key={key} 
                value={key} 
                className="flex-1 h-7 px-3 text-[12px] font-medium data-[state=on]:bg-white data-[state=on]:shadow-sm data-[state=on]:text-[#0f3460] text-gray-600 hover:text-gray-900 transition-all"
              >
                {KEYWORD_TIME_FILTER_KEYS[key]}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </div>

        <ShadcnAutoCompleteFilters
          placeholder={"Search research interest"}
          functionSearch={getSuggestKeywords}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.KEYWORD_QUERY}
          getFirstItemOnEnter
        />
      </div>

      {/* Institution */}
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Institution
        </label>
        <ShadcnAutoCompleteFilters
          placeholder={"Search by institution"}
          functionSearch={getSuggestSearchInstitutions}
          valueField="id"
          localStorageKey="inst_map"
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.INSTITUTIONS}
          getFirstItemOnEnter
        />
      </div>

    </div>
  );
};

export default FiltersUnit;
